import { PropType, computed, defineComponent, onUnmounted, reactive, ref, watch } from 'vue'
import { Store } from 'pinia'
import { ChargeMapContext } from '../../chargerMap/index.model'
import { ComponentActions, ComponentState } from '../../../nsh5/localStores/component'
import {
  addMapResources,
  calcSize,
  changeMarker,
  flyTo,
  resizeMapResources,
} from '../../chargerMap/mapUtils'
import { useRoute, useRouter } from 'vue-router'
import { gcj02ToBd09 } from '@/utils/coordinateTransform'
import { Loc, MapViewMode, Marker, Point, ZoomMode } from '../../../contract/map'
import { NewStationItemModel } from '../newStation.model'
import { PowerResourceType } from '@/contract/map.base'
import { DEFAULT_CITY_ZOOM_LEVEL } from '../../../config/zoomLevelConfig'
import { SearchPoint } from '../../../contract/searchPoint'

export default defineComponent({
  name: 'new-station-dot-render-view',
  props: {
    mapContextRef: {
      type: Object as PropType<ChargeMapContext>,
    },
    mapInstance: {
      type: Object,
    },
    componentStore: {
      // 用于同一项目功能模块间的通信
      type: Object as PropType<Store<string, ComponentState, {}, ComponentActions>>,
      default: null,
    },
  },

  setup: (props, { expose }) => {
    const mapContextRef = computed(() => props.mapContextRef)
    const mapInstance = computed(() => props.mapInstance)
    const zoomLevel = ref<number>(0)
    const hasDrawIcon = ref(false)
    let cacheClickedId = '' // 记录已经点击变大/已点击 的点
    const clickedMarkerMap: {
      [id: string]: Marker
    } = {} // 缓存点击过的点，后面可以直接通过ID获取

    const router = useRouter()
    const route = useRoute()

    const state = reactive({
      dotMap: {
        swap: [] as Point[],
        charge: [] as Point[],
      },
    })

    // 新站上新数据准备
    const renderNewStationPrepare = () => {
      console.log('====================================')
      console.log('props.componentStore.newStationList', props.componentStore.newStationList)
      console.log('====================================')
      state.dotMap.swap = []
      state.dotMap.charge = []
      props.componentStore.newStationList.map((item: NewStationItemModel) => {
        const position = item?.location.split(',')
        const point = gcj02ToBd09({
          lng: Number(position[0]),
          lat: Number(position[1]),
        })
        if (item.type === PowerResourceType.PowerSwap) {
          state.dotMap.swap.push({
            id: item?.id,
            lng: point?.lng,
            lat: point?.lat,
            type: item.type,
          } as Point)
        } else {
          state.dotMap.charge.push({
            id: item?.id,
            lng: point?.lng,
            lat: point?.lat,
            type: item.type,
          } as Point)
        }
      })
      console.log('==============state.dotMap======================')
      console.log(state.dotMap)
      console.log('====================================')
      // // 从地图大icon切换到上新，不出现大的小点，onReady会触发zoomEnd，从而触发zoomLevel变化
      // drawNewStationDot(true)
    }

    const drawNewStationDot = (display = true) => {
      console.log('=============drawNewStationDot=======================')
      console.log(display)
      console.log(mapInstance.value?.getZoom())
      console.log(calcSize(mapInstance.value?.getZoom()).w)
      console.log('====================================')
      if (state.dotMap?.charge?.length) {
        mapContextRef.value!.setPointLayer(
          state.dotMap.charge,
          '#00BEBE',
          calcSize(mapInstance.value?.getZoom()).w,
          'newStationCS',
          50,
          display
        )
      }
      if (state.dotMap?.swap?.length) {
        mapContextRef.value!.setPointLayer(
          state.dotMap.swap,
          '#1C7795',
          calcSize(mapInstance.value?.getZoom()).w,
          'newStationPS',
          50,
          display
        )
      }
    }

    const drawNewStationIcon = () => {
      if (hasDrawIcon.value) {
        return
      }
      console.log('=================drawNewStationIcon===================')
      console.log('props.componentStore.newStationList', props.componentStore.newStationList)
      console.log('====================================')
      addMapResources(mapContextRef.value!, ZoomMode.City, props.componentStore.newStationList)
      hasDrawIcon.value = true
    }

    /**
     * 选择上通过id获取marker
     */
    props.componentStore.bus.on('onClickedNewStationList', async (loc: Loc | SearchPoint) => {
      const marker = mapContextRef.value?.getMarkerById(loc.id)
      if (marker) {
        // 已经画出了点
        const point = gcj02ToBd09({
          lng: Number(loc.lng),
          lat: Number(loc.lat),
        })
        flyTo(mapContextRef.value!, point)
        props.componentStore.bus.emit('preventZoomDragAction', 3000)
        onClickedMarker(marker.customData.marker)
      } else {
        props.componentStore.$patch({
          cardLoaded: false,
        })
        // await router.replace(routeTarget)
        const point = gcj02ToBd09({
          lng: Number(loc.lng),
          lat: Number(loc.lat),
        })
        flyTo(mapContextRef.value!, point, 13) // 会触发watch zoomLevel 变化请求around接口
        // 有一个fly的过程，所以延迟2秒再请求周围资源点
        setTimeout(() => {
          // 如果当前层级已经是17，不会触发watch zoomLevel 变化请求around接口, 需要手动调用
          onClickedMarker(mapContextRef.value?.getMarkerById(loc.id).customData.marker)
        }, 3000)
      }
    })
    /**
     * 点击地图上的点
     * @param customMarkerData
     * @returns
     */
    const onClickedMarker = (customMarkerData: Marker) => {
      if (cacheClickedId == customMarkerData.id) {
        // 防止对同一个点多次点击
        return
      }
      changeMarker(mapContextRef.value!, customMarkerData.id, cacheClickedId || '')
      cacheClickedId = customMarkerData.id
      if (props.componentStore.viewMode === MapViewMode.NewStation) {
        clickedMarkerMap[customMarkerData.id] = customMarkerData
        const resource: any = customMarkerData?.data
        props.componentStore.bus.emit('clickedMarker', customMarkerData) // 触发画圈
        if (resource) {
          const routeTarget = {
            name: 'resource',
            query: {
              id: resource.id,
              location: resource.location,
              pointType: resource.pointType,
              pointSubType: resource.pointSubType,
            },
            state: {
              backHistoryNum: window.backHistoryNum,
            },
          }
          if (route.name == 'newStation') {
            window.backHistoryNum++
            routeTarget.state.backHistoryNum = window.backHistoryNum
            router.push(routeTarget)
          } else {
            router.replace(routeTarget)
          }
          const [lng, lat] = resource.location?.split(',') || [0, 0]
          const point = gcj02ToBd09({
            lng: Number(lng),
            lat: Number(lat),
          })
          // 设置目的地，显示小气泡
          props.componentStore.setDestLocationByPin({
            name: resource.name || 'Oops！未获取到名称',
            lng: point.lng,
            lat: point.lat,
            address: resource.address,
          })
          props.componentStore.$patch({
            cardLoaded: true,
          })
        }
      }
    }

    props.componentStore.bus.on('newStationClickedMarker', onClickedMarker)

    // ------------暴露出去的方法--------------
    const zoomEnd = async () => {
      zoomLevel.value = mapInstance.value?.getZoom()
    }

    // 启动相关事件监听
    const initEventListener = () => {
      mapInstance.value?.addEventListener('zoomend', zoomEnd, false)
    }

    onUnmounted(() => {
      props.componentStore.bus.off('onClickedNewStationList')
      props.componentStore.bus.off('newStationClickedMarker')
    })

    /**
     * 组件获取地图实例后的回调
     */
    const onReady = async () => {
      initEventListener()
      renderNewStationPrepare()
      if (zoomLevel.value > DEFAULT_CITY_ZOOM_LEVEL) {
        // 清空原有的大ICON，重新画大ICON
        mapContextRef.value?.removeMarkers()
        hasDrawIcon.value = false // 切换到上新，重新画大icon
        drawNewStationIcon()
      } else if (zoomLevel.value <= DEFAULT_CITY_ZOOM_LEVEL) {
        // 清空原有的小店，重新画小店
        mapContextRef.value?.removePointLayer(['newStationCS', 'newStationPS'])
        // 从地图大icon切换到上新，不出现大的小点，onReady会触发zoomEnd，从而触发zoomLevel变化
        drawNewStationDot(true)
      }
      // renderNewStationDot()
    }
    watch(
      () => [props.mapContextRef, props.componentStore.newStationList],
      (newVal, oldVal) => {
        if (props.mapContextRef && props.componentStore.newStationList) {
          // 若无上新数据，需要清空
          console.log('==============ready======================')
          console.log('ready')
          console.log('====================================')
          onReady()
        }
      },
      {
        immediate: true,
      }
    )

    watch(
      () => route.name,
      (newVal, oldVal) => {
        // 上新资源点退回到上新列表
        if (newVal === 'newStation' && oldVal === 'resource') {
          props.componentStore.unsetDestLocationByPin() // 小气泡消失
          if (zoomLevel.value > DEFAULT_CITY_ZOOM_LEVEL) {
            changeMarker(mapContextRef.value!, '', cacheClickedId || '') // 大icon变小icon
          } else if (zoomLevel.value <= DEFAULT_CITY_ZOOM_LEVEL) {
            mapContextRef.value?.removeMarkers()
          }
          cacheClickedId = ''
        }
      }
    )

    watch(
      () => props.componentStore.viewMode,
      (newVal, oldVal) => {
        if (newVal === MapViewMode.NewStation) {
          // 首页到上新模式
          cacheClickedId = ''
          if (zoomLevel.value < DEFAULT_CITY_ZOOM_LEVEL) {
            drawNewStationDot(true)
          }
        } else {
          // 上新模式返回首页
          drawNewStationDot(false)
        }
      },
      { immediate: true }
    )

    watch(
      () => zoomLevel.value,
      (newVal) => {
        if (newVal > DEFAULT_CITY_ZOOM_LEVEL) {
          // 放大消失
          drawNewStationDot(false)
          // 显示大icon
          drawNewStationIcon()
          // hasDrawIcon.value = true
        } else if (newVal <= DEFAULT_CITY_ZOOM_LEVEL) {
          // 缩小显示
          drawNewStationDot(true)
          // 移除大icon
          mapContextRef.value?.removeMarkers()
          props.componentStore.unsetDestLocationByPin() // 小气泡消失
          hasDrawIcon.value = false
          if (route.name == 'resource') {
            router.go(-1)
          }
        }
        resizeMapResources(mapContextRef.value!, calcSize(zoomLevel.value).w) // 调整点的大小
      }
    )

    expose({
      onClickedMarker,
    })

    return () => {}
  },
})
